
    import './styles.scoped.css';
    export default {
  "expand-toggle-icon": "awsui_expand-toggle-icon_1xe88_gapvi_13",
  "expand-toggle-icon-expanded": "awsui_expand-toggle-icon-expanded_1xe88_gapvi_34",
  "expand-toggle": "awsui_expand-toggle_1xe88_gapvi_13",
  "disable-focus-highlight": "awsui_disable-focus-highlight_1xe88_gapvi_85"
};
  